import React, { useState, useEffect, useRef } from 'react';
import clsx from 'clsx';
import styles from './subscriptionPayment.module.css';
import logo from '../../assets/images/verticaltv/Vertical by Zupee.svg';
import { useNavigate } from 'react-router-dom';
import upiGroupImages from '../../assets/upi_group_images.svg';
import { NAVIGATION_ROUTES } from '../../constant';
import SubscriptionDetailsCard from '../../components/SubscriptionDetailsCard';
import UpiIdTextBox from '../../components/pwatv/UpiIdTextBox';
import { PaidPlanSubscription } from '../../components/pwatv';
import { useGetPlanStateV3 } from '../../api/getPlanState';
import { useGetSubscriptionStatus } from '../../api/getSubscriptionStatus';
import { useInitiateSubscriptionCheckout } from '../../api/initiateCheckout';
import { useCreateCheckoutOrder } from '../../api/createCheckoutOrder';
import Loader from '../../components/Loader';
import { useTokenStore } from '../../storage/tokenState';
import { handleUpiMandateUri } from '../../utils/paymentDeepLink';
import { CLEVERTAP_EVENTS } from '../../analytics/trackerEvents/cleverTap/events';
import { CT_PARAMS } from '../../analytics/trackerEvents/cleverTap/parameters';
import { trackCleverTapEvent } from '../../utils/cleverTapHelper';
import { FbPixelEvent_AddPaymentInfo } from '../../utils/FbPixel/fbPixel';
import { fireAddPaymentInfoEvent } from '../../utils/SmartScriptAppFlyer/appsFlyerEvents';
import { pushGAEvent, GA_EVENTS } from '../../utils/gaHelper';
import { useSubscriptionPaymentStore } from '../../storage/subscriptionPaymentStore';



const SubscriptionPayment: React.FC = () => {
  const navigate = useNavigate();
  const [showUpiInput, setShowUpiInput] = useState(false);
  const [isTrialScreen, setIsTrialScreen] = useState<boolean>(false);
  const [checkoutSessionId, setCheckoutSessionId] = useState<string>('');
  const [planAmount, setPlanAmount] = useState<number>(0); // API amount (₹549 for trial, actualPrice for paid)
  const [displayAmount, setDisplayAmount] = useState<number>(0); // Display amount (₹2 for trial, same as planAmount for paid)
  const [currentPlanId, setCurrentPlanId] = useState<string>('');
  const [showPaymentOptions, setShowPaymentOptions] = useState(false);
  const [upiOptions, setUpiOptions] = useState<Array<{
    type: string;
    itemId: string;
    iconUrl: string;
    name: string;
    isEnabled: boolean;
  }>>([]);

  const [buttonNameState, setButtonNameState] = useState<string>('');


  const [sessionIdCollect, setSessionIdCollect] = useState<any>('');
  const [isInitialCheckoutLoadingScreen, setIsInitialCheckoutLoadingScreen] = useState<boolean>(false);
  

  const subscriptionPaymentDataCtx = useSubscriptionPaymentStore((state) => state.subscriptionPaymentDataCtx);
  const setSubscriptionPaymentDataCtx = useSubscriptionPaymentStore((state) => state.setSubscriptionPaymentDataCtx);

  
  // Get user's phone number from token store
  const { token } = useTokenStore();

  
  // Get the full phone number (signupPhoneNumber has the complete number without masking)
  // Format it with country code if it doesn't have one
  const getFormattedPhoneNumber = () => {
    if (token?.signupPhoneNumber) {
      // If signupPhoneNumber doesn't start with +, add +91
      const phoneNumber = token.signupPhoneNumber;
      if (phoneNumber.startsWith('+')) {
        return phoneNumber;
      } else if (phoneNumber.startsWith('91')) {
        return `+${phoneNumber}`;
      } else {
        return `+91${phoneNumber}`;
      }
    }
    // Fallback to un if signupPhoneNumber is not available
    return token?.un || '';
  };
  
  const userPhoneNumber = getFormattedPhoneNumber();
  
  // State to track subscription status check
  const [subscriptionCheckDone, setSubscriptionCheckDone] = useState(false);
  const [shouldLoadPlanState, setShouldLoadPlanState] = useState(false);
  const hasCheckedSubscriptionRef = useRef(false);
  const paymentScreenViewTrackedRef = useRef(false);
  
  // Get subscription status hook
  const { checkSubscriptionStatus, isLoading: isCheckingSubscription } = useGetSubscriptionStatus();
  
  // Track CleverTap event when user lands on payment screen
  useEffect(() => {
    // Prevent duplicate event firing (handles React.StrictMode double-mounting)
    if (paymentScreenViewTrackedRef.current) {
      return;
    }
    paymentScreenViewTrackedRef.current = true;
    const userId = token?.zupeeUserId?.toString() || '';
    trackCleverTapEvent(CLEVERTAP_EVENTS.WEB_EVENT_PAYMENT_SCREEN_VIEW, {
      [CT_PARAMS.USER_ID]: userId
    });
  }, [token?._id, token?.zupeeUserId]);

const initalCheckoutData = async (amount: number, planId: string) => {
    setIsInitialCheckoutLoadingScreen(true);
    if(!planId){
      console.error('planId not available');
      setIsInitialCheckoutLoadingScreen(false);
      return;
    }
try {
               // Step 1: Initiate subscription checkout
           
               const checkoutResponse = await initiateCheckoutAsync({
                amount: amount,
                 //amount: 549,
                 autoMandate: true,
                 planId: planId,
                 referralCouponApplied: false,
                 shouldFetchCustomerDetails: true,
                 isUpiAvailable: false
               });

              console.log('checkoutResponse', checkoutResponse);
               
               if (!checkoutResponse?.response?.success || !checkoutResponse?.response?.data?.sessionId) {
                 console.error('Failed to initiate checkout');
                 //setError(true);
               }

              let instrumentType = 'qr_collect'; // Default fallback

              let upiLogos: any[] = [];
               const upiWidgetOR = checkoutResponse?.response?.data?.paymentConfigData.find(
                (widget: any) => widget.widgetSubType === 'QR_UPI'
              );

              if (upiWidgetOR && upiWidgetOR?.upiLogos && upiWidgetOR?.upiLogos?.length > 0) {
                upiLogos = [...upiLogos, ...upiWidgetOR.upiLogos];
              }

              let scannerText = '';
              if (upiWidgetOR && upiWidgetOR?.description && upiWidgetOR?.description?.text) {
                scannerText = upiWidgetOR.description.text;
              }

              let messageData = '';
              if (upiWidgetOR && upiWidgetOR?.messageData && upiWidgetOR?.messageData?.text) {
                messageData = upiWidgetOR.messageData.text;
              }

              let sharedData: any = {};
              if (upiWidgetOR && upiWidgetOR?.sharedData) {
                sharedData = upiWidgetOR.sharedData;
              }

              // Polling interval for getOrderStatus (fallback 15s)
              let qrPollingConfig =  15000
              if (upiWidgetOR && upiWidgetOR?.qrPollingConfig?.pollingTimeMs !== null) {
                const parsed = Number(upiWidgetOR?.qrPollingConfig?.pollingTimeMs);
                if (!Number.isNaN(parsed)) {
                  qrPollingConfig = parsed;
                }
              }

              const upiButtonName = checkoutResponse?.response?.data?.paymentConfigData?.find((widget: any) => widget?.widgetSubType === 'QR_UPI')?.widgetSubType ? 'Pay using QR Code' : 'Or Enter UPI ID';
              setButtonNameState(upiButtonName);
               setSubscriptionPaymentDataCtx((prev: any) => ({ ...prev, sessionIdCtx: checkoutResponse?.response?.data?.sessionId, sessionTimestampCtx: checkoutResponse?.response?.data?.sessionTimestamp, upiLogosCtx: upiLogos, paymentConfigDataCtx: checkoutResponse?.response?.data?.paymentConfigData, instrumentTypeCtx: instrumentType, messageDataCtx: messageData, scannerTextCtx: scannerText, sharedDataCtx: sharedData, qrPollingConfigCtx: qrPollingConfig, subtypewidgetUpiCtx:checkoutResponse?.response?.data?.paymentConfigData?.find((widget: any) => widget?.widgetSubType === 'QR_UPI')?.widgetSubType ? 'QR_UPI' : '' }));
               setIsInitialCheckoutLoadingScreen(false);
       
           }   catch (error) {
               console.error('Error initiating checkout:', error);
               //setError(true);
               setIsInitialCheckoutLoadingScreen(false);
           }

}

  // Check subscription status before calling getPlanStateV3
  useEffect(() => {
    const checkSubscription = async () => {
      if (!token?.accessToken || hasCheckedSubscriptionRef.current) {
        return;
      }
      
      hasCheckedSubscriptionRef.current = true;
      
      try {
        console.log('Checking subscription status before calling getPlanStateV3...');
        const response = await checkSubscriptionStatus();
        console.log('Subscription status response:', response);
        
        if (response?.response?.success) {
          const zupeeTvSubscription = response?.response?.data?.activeSubscriptionsData?.ZUPEE_TV;
          console.log('ZUPEE_TV subscription data:', zupeeTvSubscription);
          
          if (zupeeTvSubscription?.isActive === true) {
            console.log('User has active subscription, redirecting to subscribed screen');
            navigate(NAVIGATION_ROUTES.REFERRAL_SUBSCRIBED, { replace: true });
            return;
          }
        }
        
        // If subscription is not active, proceed with normal flow
        console.log('User does not have active subscription, proceeding with plan state fetch');
        setShouldLoadPlanState(true);
        setSubscriptionCheckDone(true);
        console.log('State updated: shouldLoadPlanState=true, subscriptionCheckDone=true');
      } catch (error) {
        console.error('Error checking subscription status:', error);
        // On error, proceed with normal flow
        setShouldLoadPlanState(true);
        setSubscriptionCheckDone(true);
        console.log('Error occurred, proceeding with plan state fetch');
      }
    };
    
    checkSubscription();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token?.accessToken]);
  
  // Fetch plan state from API (only after subscription check is done and subscription is not active)
  // Only enable if we have a token and should load plan state
  const { planStateData, isLoading, error } = useGetPlanStateV3(shouldLoadPlanState && !!token?.accessToken);

  console.log('planStateData', planStateData);
  
  // Debug: Log when plan state loading should start
  useEffect(() => {
    if (shouldLoadPlanState) {
      console.log('Plan state loading enabled. isLoading:', isLoading, 'hasData:', !!planStateData, 'hasError:', !!error);
    }
  }, [shouldLoadPlanState, isLoading, planStateData, error]);
  
  // Initiate checkout mutation
  const { initiateCheckoutAsync, isLoading: isCheckoutLoading } = useInitiateSubscriptionCheckout();
  
  // Create checkout order mutation
  const { createOrderAsync, isLoading: isCreatingOrder } = useCreateCheckoutOrder();

  // Process API response and extract plan details
  useEffect(() => {
    if (planStateData?.response?.success && planStateData?.response?.data) {
      const responseData = planStateData.response.data;
      
      // Check if it's a trial screen (inactiveFreePlanState)
      if (responseData.inactiveFreePlanState) {
        setIsTrialScreen(true);
        
        // Extract trial plan details for checkout
        const trialData = responseData.inactiveFreePlanState;
        if (trialData.planId) {
          setCurrentPlanId(trialData.planId);
        }
        // For trial screen:
        // - planAmount = full plan amount (₹549) - for API calls
        // - displayAmount = trial amount (₹2) - for UI display
        const fullPlanAmount = parseInt(trialData.webView?.planAmount?.replace(/[^\d]/g, '') || '549');
        const trialAmount = parseInt(trialData.webView?.trialAmount?.replace(/[^\d]/g, '') || '2');
        
        setPlanAmount(fullPlanAmount); // ₹549 for API
        setDisplayAmount(trialAmount); // ₹2 for display
        
        setSubscriptionPaymentDataCtx((prev: any) => ({ ...prev, planAmountCtx: trialAmount, planIdCtx: trialData?.planId || '', subscriptionStatusCtx: [{ ...prev.subscriptionStatusCtx[0], isEnabled: true }, { ...prev.subscriptionStatusCtx[1], isEnabled: false }] }));

        initalCheckoutData(fullPlanAmount,trialData?.planId || '');

        console.log('Trial screen - planAmount (API):', fullPlanAmount, 'displayAmount (UI):', trialAmount, 'planId:', trialData.planId);
      }
      // Check if it's a paid plan screen (inactivePaidPlanState)
      else if (responseData.inactivePaidPlanState) {
        setIsTrialScreen(false);
        
        
        // For PAID plan screen: both amounts are the same
        const paidPlanData = responseData.inactivePaidPlanState.planData?.plans?.[0];
        if (paidPlanData) {
          setCurrentPlanId(paidPlanData.id);
          const amount = paidPlanData.actualPriceAmount;
          setPlanAmount(amount);
          setDisplayAmount(amount); // Same as planAmount for paid plans

          setSubscriptionPaymentDataCtx((prev: any) => ({ ...prev, planAmountCtx: amount, planIdCtx: paidPlanData.id, subscriptionStatusCtx: [{ ...prev.subscriptionStatusCtx[0], isEnabled: false }, { ...prev.subscriptionStatusCtx[1], isEnabled: true }] }));

          initalCheckoutData(amount,paidPlanData?.id || '');
          
          console.log('Paid plan screen - planAmount:', amount, 'planId:', paidPlanData.id);
        }
      }
    }

  }, [planStateData]);

  useEffect(() => {
    console.log('subscriptionPaymentDataCtx', subscriptionPaymentDataCtx);
  }, [subscriptionPaymentDataCtx]);


  const handleUpiOptionClick = async (itemId: string) => {
    console.log('UPI option clicked:', itemId);
    
    if (!checkoutSessionId) {
      console.error('SessionId not available');
      alert('Payment session not ready. Please wait...');
      return;
    }
    
    try {
      // Map itemId to instrumentType
      let instrumentType = itemId;
      let paymentMode = 'UPI';
      
      // Create checkout order using stored sessionId
      const orderResponse = await createOrderAsync({
        amount: planAmount,
        constraintId: checkoutSessionId,
        customerVpa: '', // Not needed for UPI app payments
        instrumentType: instrumentType,
        isNewSavedCard: false,
        paymentMode: paymentMode
      });

      if (orderResponse?.response?.success && orderResponse?.response?.data) {
        const orderData = orderResponse.response.data;
        
        console.log('Order created:', {
          orderId: orderData.orderId,
          mandateUri: orderData.mandateFlowData?.mandateUri,
          amount: orderData.amount
        });
        
        // Handle UPI Autopay Mandate URI
        if (orderData.mandateFlowData?.mandateUri) {
          // Navigate to PaymentWaiting screen first, then open UPI app
          // This ensures user returns to PaymentWaiting screen after payment
          handleUpiMandateUri(
            orderData.mandateFlowData.mandateUri,
            orderData.orderId,
            orderData.amount,
            'UPI app', // You can customize this based on pgName if needed
            navigate
          );
        } else {
          console.warn('No mandate URI received in response');
          alert('Payment initiated. Order ID: ' + orderData.orderId);
        }
      } else {
        console.error('Order creation failed');
        alert('Failed to create order. Please try again.');
      }
    } catch (error) {
      console.error('Error processing payment:', error);
      alert('Failed to process payment. Please try again.');
    }
  };

  const handlePaymentButtonClick = async () => {
    console.log('Payment button clicked', { planAmount, currentPlanId });
    
    // Track CleverTap event when user clicks UPI pay button
    // If displayAmount is ₹2, it's trial; otherwise subscription
    const userId = token?.zupeeUserId?.toString() || '';
    trackCleverTapEvent(CLEVERTAP_EVENTS.WEB_EVENT_CLICK_UPI_PAY, {
      [CT_PARAMS.USER_ID]: userId,
      [CT_PARAMS.TYPE]: displayAmount === 2 ? CT_PARAMS.TRIAL : CT_PARAMS.SUBSCRIPTION
    });
    
    if (!planAmount || !currentPlanId) {
      console.error('Plan details not available');
      alert('Subscription details not ready. Please wait...');
      return;
    }
    
    // Prevent multiple clicks
    if (isCheckoutLoading || isCreatingOrder) {
      return;
    }
    
    // Check if payment is already in processing
    const pendingOrderId = sessionStorage.getItem('pendingOrderId');
    const mandateUriOpened = sessionStorage.getItem('mandateUriOpened');
    
    if (pendingOrderId) {
      console.log('Payment already in processing. Navigating to payment-processing screen...');
      
      // Ensure mandateUriOpened flag is set for polling to work
      if (!mandateUriOpened) {
        sessionStorage.setItem('mandateUriOpened', 'true');
      }
      
      // Navigate directly to payment-processing screen
      navigate('/payment-processing', {
        state: {
          orderId: pendingOrderId,
          amount: parseInt(sessionStorage.getItem('pendingPaymentAmount') || planAmount.toString(), 10),
          appName: 'UPI app'
        }
      });
      return;
    }
    
    try {
      // Step 1: Initiate subscription checkout
      console.log('Initiating subscription checkout:', {
        amount: planAmount,
        planId: currentPlanId
      });
      const checkoutResponse = await initiateCheckoutAsync({
        amount: planAmount,
        autoMandate: true,
        planId: currentPlanId,
        referralCouponApplied: false,
        shouldFetchCustomerDetails: true
      });
      
      if (!checkoutResponse?.response?.success || !checkoutResponse?.response?.data?.sessionId) {
        console.error('Failed to initiate checkout');
        alert('Failed to initiate payment. Please try again.');
        return;
      }
      
      const sessionId = checkoutResponse.response.data.sessionId;
      console.log('Checkout initiated, sessionId:', sessionId);
      
      // Track Facebook Pixel AddPaymentInfo event when payment gateway is initiated
      FbPixelEvent_AddPaymentInfo();
      // Track AppsFlyer AddPaymentInfo event
      fireAddPaymentInfoEvent({ paymentMethod: 'UPI', page: 'subscription_payment' });
      
      // Step 2: Get UPI options from paymentConfigData (use first available UPI option)
      const paymentConfigData = checkoutResponse.response.data.paymentConfigData || [];
      const upiWidget = paymentConfigData.find(
        (widget: any) => widget.widgetSubType === 'UPI' && widget.items
      );
      
      let instrumentType = 'upi_collect'; // Default fallback
      if (upiWidget && upiWidget.items && upiWidget.items.length > 0) {
        const firstUpiOption = upiWidget.items.find((item: any) => item.isEnabled);
        if (firstUpiOption) {
          instrumentType = firstUpiOption.itemId || firstUpiOption.type || 'upi_collect';
        }
      }

      // Step 3: Create checkout order
      console.log('Creating checkout order:', {
        amount: planAmount,
        sessionId: sessionId,
        instrumentType: instrumentType
      });
      
      const orderResponse = await createOrderAsync({
        amount: planAmount,
        constraintId: sessionId,
        customerVpa: '', // Not needed for UPI app payments
        instrumentType: instrumentType,
        isNewSavedCard: false,
        paymentMode: 'UPI'
      });

      // Check for "Payment in Progress" screenError first
      if (
        orderResponse?.response?.success && 
        orderResponse?.response?.screenError?.title === 'Payment in Progress'
      ) {
        console.log('Payment already in progress. Navigating to payment-processing screen...', {
          screenError: orderResponse.response.screenError
        });
        
        // Get orderId from sessionStorage (payment is already in progress)
        const pendingOrderId = sessionStorage.getItem('pendingOrderId');
        const pendingAmount = sessionStorage.getItem('pendingPaymentAmount');
        
        if (pendingOrderId) {
          // Ensure mandateUriOpened flag is set for polling to work
          sessionStorage.setItem('mandateUriOpened', 'true');
          
          // Navigate to payment-processing screen to continue polling
          navigate('/payment-processing', {
            state: {
              orderId: pendingOrderId,
              amount: parseInt(pendingAmount || planAmount.toString(), 10),
              appName: 'UPI app'
            }
          });
        } else {
          // If no orderId in sessionStorage, still navigate to payment-processing
          // The screen will handle the case where orderId is missing
          console.warn('Payment in progress but no orderId found in sessionStorage');
          sessionStorage.setItem('mandateUriOpened', 'true');
          
          navigate('/payment-processing', {
            state: {
              orderId: null,
              amount: planAmount,
              appName: 'UPI app'
            }
          });
        }
        return;
      }

      if (orderResponse?.response?.success && orderResponse?.response?.data) {
        const orderData = orderResponse.response.data;
        
        console.log('Order created:', {
          orderId: orderData.orderId,
          mandateUri: orderData.mandateFlowData?.mandateUri,
          amount: orderData.amount
        });
        
        // Step 4: Handle UPI Autopay Mandate URI
        if (orderData.mandateFlowData?.mandateUri) {
          handleUpiMandateUri(
            orderData.mandateFlowData.mandateUri,
            orderData.orderId,
            orderData.amount,
            'UPI app',
            navigate
          );
        } else {
          console.warn('No mandate URI received in response');
          alert('Payment initiated. Order ID: ' + orderData.orderId);
        }
      } else {
        // Check if payment is already in processing
        const pendingOrderId = sessionStorage.getItem('pendingOrderId');
        const mandateUriOpened = sessionStorage.getItem('mandateUriOpened');
        
        // If there's a pending order, payment is likely in processing
        if (pendingOrderId) {
          console.log('Payment already in processing. Navigating to payment-processing screen...');
          
          // Ensure mandateUriOpened flag is set for polling to work
          if (!mandateUriOpened) {
            sessionStorage.setItem('mandateUriOpened', 'true');
          }
          
          // Navigate to payment-processing screen with existing orderId
          navigate('/payment-processing', {
            state: {
              orderId: pendingOrderId,
              amount: parseInt(sessionStorage.getItem('pendingPaymentAmount') || planAmount.toString(), 10),
              appName: 'UPI app'
            }
          });
        } else {
          console.error('Order creation failed');
          alert('Failed to create order. Please try again.');
        }
      }
    } catch (error: any) {
      console.error('Error processing payment:', error);
      
      // Check if payment is already in processing (from error response or sessionStorage)
      const pendingOrderId = sessionStorage.getItem('pendingOrderId');
      const mandateUriOpened = sessionStorage.getItem('mandateUriOpened');
      
      // Check error message/response for "already processing" or "duplicate order" indicators
      const errorMessage = error?.response?.data?.response?.message || error?.message || '';
      const isProcessingError = 
        errorMessage.toLowerCase().includes('already') ||
        errorMessage.toLowerCase().includes('processing') ||
        errorMessage.toLowerCase().includes('duplicate') ||
        errorMessage.toLowerCase().includes('pending') ||
        error?.response?.status === 409; // Conflict status code
      
      // If there's a pending order or error indicates payment is processing, navigate to payment-processing
      if (pendingOrderId || isProcessingError) {
        console.log('Payment already in processing. Navigating to payment-processing screen...');
        
        const orderIdToUse = pendingOrderId || error?.response?.data?.response?.data?.orderId;
        const amountToUse = parseInt(
          sessionStorage.getItem('pendingPaymentAmount') || planAmount.toString(), 
          10
        );
        
        if (orderIdToUse) {
          // Store orderId if not already stored
          if (!pendingOrderId) {
            sessionStorage.setItem('pendingOrderId', orderIdToUse);
            sessionStorage.setItem('pendingPaymentAmount', amountToUse.toString());
          }
          
          // Ensure mandateUriOpened flag is set for polling to work
          if (!mandateUriOpened) {
            sessionStorage.setItem('mandateUriOpened', 'true');
          }
          
          // Navigate to payment-processing screen
          navigate('/payment-processing', {
            state: {
              orderId: orderIdToUse,
              amount: amountToUse,
              appName: 'UPI app'
            }
          });
        } else {
          alert('Failed to process payment. Please try again.');
        }
      } else {
        alert('Failed to process payment. Please try again.');
      }
    }
  };

  

  const handleEnterUpiId = async () => {
    // Track CleverTap event when user clicks Enter UPI ID (collect flow)
    // If displayAmount is ₹2, it's trial; otherwise subscription
  
    
    // Just open the UPI input modal - API call will happen when user clicks Pay button
    if (!planAmount || !currentPlanId) {
      console.error('Plan details not available');
      alert('Subscription details not ready. Please wait...');
      return;
    }

    console.log('subscriptionPaymentDataCtx.subtypewidgetUpiCtx', subscriptionPaymentDataCtx);

    if(subscriptionPaymentDataCtx.subtypewidgetUpiCtx === 'QR_UPI'){

      const userId = token?.zupeeUserId?.toString() || '';
      trackCleverTapEvent(CLEVERTAP_EVENTS.WEB_EVENT_CLICK_QR_PAY, {
        [CT_PARAMS.USER_ID]: userId,
        [CT_PARAMS.TYPE]: displayAmount === 2 ? CT_PARAMS.TRIAL : CT_PARAMS.SUBSCRIPTION
      });

      navigate('/qr-code');
    }else{

      const userId = token?.zupeeUserId?.toString() || '';
      trackCleverTapEvent(CLEVERTAP_EVENTS.WEB_EVENT_CLICK_COLLECT_PAY, {
        [CT_PARAMS.USER_ID]: userId,
        [CT_PARAMS.TYPE]: displayAmount === 2 ? CT_PARAMS.TRIAL : CT_PARAMS.SUBSCRIPTION
      });

      setShowUpiInput(true);
    }

    //setShowUpiInput(true);
    //navigate('/qr-code');
  };




  const handleBackToPaymentOptions = () => {
    setShowUpiInput(false);
  };

  // Detect when user returns from UPI app and navigate to payment-processing
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        const shouldNavigate = sessionStorage.getItem('shouldNavigateToProcessing');
        const mandateUriOpened = sessionStorage.getItem('mandateUriOpened');
        const pendingOrderId = sessionStorage.getItem('pendingOrderId');
        
        // If user returned from UPI app, navigate to payment-processing
        if (shouldNavigate === 'true' && mandateUriOpened === 'true' && pendingOrderId) {
          console.log('User returned from UPI app. Navigating to payment-processing...');
          
          // Clear the flag
          sessionStorage.removeItem('shouldNavigateToProcessing');
          
          // Navigate to payment-processing with order details
          navigate('/payment-processing', {
            state: {
              orderId: pendingOrderId,
              amount: parseInt(sessionStorage.getItem('pendingPaymentAmount') || '0', 10),
              appName: 'UPI app'
            }
          });
        }
      }
    };

    // Listen for visibility changes
    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    // Also listen for focus (when user switches back to tab)
    window.addEventListener('focus', handleVisibilityChange);

    // Check immediately if page is already visible
    if (document.visibilityState === 'visible') {
      handleVisibilityChange();
    }

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleVisibilityChange);
    };
  }, [navigate]);

  // Show loader while checking subscription status (before we know the result)
  if (!subscriptionCheckDone) {
    return <Loader />;
  }
  
  // After subscription check is done and we need to load plan state
  // Show loader if we're loading OR if we don't have data yet (query might be starting or in progress)
  if (shouldLoadPlanState) {
    if (isLoading || (!planStateData && !error)) {
      return <Loader />;
    }
  }

  // Only show error if subscription check is done, we're trying to load plan state, and we have an error or no plan data (and not loading)
  if (subscriptionCheckDone && shouldLoadPlanState && !isLoading && (error || !planStateData)) {
    return (
      <div className={styles.container}>
        <div className={styles.content}>
          <div style={{ textAlign: 'center', padding: '20px', color: '#F3F4F6' }}>
            <p style={{ marginBottom: '16px' }}>
              {error ? 'Failed to load subscription plans.' : 'Please log in to view subscription plans.'}
            </p>
            <button
              onClick={() => navigate(NAVIGATION_ROUTES.REFERRAL_SIGNUP)}
              style={{
                background: 'linear-gradient(99deg, #00FF5E 0%, #00FFC3 101.74%)',
                color: '#0D0E11',
                padding: '12px 24px',
                borderRadius: '12px',
                border: 'none',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              {error ? 'Go Back' : 'Log In'}
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Check if we have paid plan state
  const paidPlanState = planStateData?.response?.data?.inactivePaidPlanState;

  // If paid plan state exists, render the PaidPlanSubscription component
  if (paidPlanState) {
    const handlePlanSelect = (planId: string) => {
      setCurrentPlanId(planId);
      const selectedPlan = paidPlanState.planData?.plans?.find(p => p.id === planId);
      if (selectedPlan) {
        setPlanAmount(selectedPlan.actualPriceAmount);
        setDisplayAmount(selectedPlan.actualPriceAmount);
      }
    };

    const handlePayClick = async (planId: string, autopayEnabled: boolean) => {
      console.log('Payment button clicked', { planAmount, currentPlanId, planId });
     
      // Track CleverTap event when user clicks UPI pay button
      // If displayAmount is ₹2, it's trial; otherwise subscription
      const userId = token?.zupeeUserId?.toString() || '';
      trackCleverTapEvent(CLEVERTAP_EVENTS.WEB_EVENT_CLICK_UPI_PAY, {
        [CT_PARAMS.USER_ID]: userId,
        [CT_PARAMS.TYPE]: displayAmount === 2 ? CT_PARAMS.TRIAL : CT_PARAMS.SUBSCRIPTION
      });
      
      // Get the selected plan to get the correct amount
      const selectedPlan = paidPlanState.planData?.plans?.find(p => p.id === planId);
      const amountToUse = selectedPlan?.actualPriceAmount || planAmount;
      
      if (!amountToUse || !planId) {
        console.error('Plan details not available');
        alert('Subscription details not ready. Please wait...');
        return;
      }
      
      // Update state with selected plan amount
      if (selectedPlan) {
        setPlanAmount(selectedPlan.actualPriceAmount);
        setDisplayAmount(selectedPlan.actualPriceAmount);
        setCurrentPlanId(planId);
      }
      
      // Prevent multiple clicks
      if (isCheckoutLoading || isCreatingOrder) {
        return;
      }
      
      // Check if payment is already in processing
      const pendingOrderId = sessionStorage.getItem('pendingOrderId');
      const mandateUriOpened = sessionStorage.getItem('mandateUriOpened');
      
      if (pendingOrderId) {
        console.log('Payment already in processing. Navigating to payment-processing screen...');
        
        // Ensure mandateUriOpened flag is set for polling to work
        if (!mandateUriOpened) {
          sessionStorage.setItem('mandateUriOpened', 'true');
        }
        
        // Navigate directly to payment-processing screen
        navigate('/payment-processing', {
          state: {
            orderId: pendingOrderId,
            amount: parseInt(sessionStorage.getItem('pendingPaymentAmount') || amountToUse.toString(), 10),
            appName: 'UPI app'
          }
        });
        return;
      }
      
      try {
        // Step 1: Initiate subscription checkout
        console.log('Initiating subscription checkout:', {
          amount: amountToUse,
          planId: planId
        });
        
        const checkoutResponse = await initiateCheckoutAsync({
          amount: amountToUse,
          autoMandate: autopayEnabled,
          planId: planId,
          referralCouponApplied: false,
          shouldFetchCustomerDetails: true
        });
        
        if (!checkoutResponse?.response?.success || !checkoutResponse?.response?.data?.sessionId) {
          console.error('Failed to initiate checkout');
          alert('Failed to initiate payment. Please try again.');
          return;
        }
        
        const sessionId = checkoutResponse.response.data.sessionId;
        console.log('Checkout initiated, sessionId:', sessionId);
        
        // Track Facebook Pixel AddPaymentInfo event when payment gateway is initiated
        FbPixelEvent_AddPaymentInfo();
        // Track AppsFlyer AddPaymentInfo event
        fireAddPaymentInfoEvent({ paymentMethod: 'UPI', page: 'paid_plan_subscription' });
        // Track GA event for payment gateway initiated
        pushGAEvent(GA_EVENTS.PAYMENT_GATEWAY_INITIATED, {
          amount: amountToUse,
          user_id: userId
        });
        
        // Step 2: Get UPI options from paymentConfigData (use first available UPI option)
        const paymentConfigData = checkoutResponse.response.data.paymentConfigData || [];
        const upiWidget = paymentConfigData.find(
          (widget: any) => widget.widgetSubType === 'UPI' && widget.items
        );
        
        let instrumentType = 'upi_collect'; // Default fallback
        if (upiWidget && upiWidget.items && upiWidget.items.length > 0) {
          const firstUpiOption = upiWidget.items.find((item: any) => item.isEnabled);
          if (firstUpiOption) {
            instrumentType = firstUpiOption.itemId || firstUpiOption.type || 'upi_collect';
          }
        }

        // Step 3: Create checkout order
        console.log('Creating checkout order:', {
          amount: amountToUse,
          sessionId: sessionId,
          instrumentType: instrumentType
        });
        
        const orderResponse = await createOrderAsync({
          amount: amountToUse,
          constraintId: sessionId,
          customerVpa: '', // Not needed for UPI app payments
          instrumentType: instrumentType,
          isNewSavedCard: false,
          paymentMode: 'UPI'
        });

        // Check for "Payment in Progress" screenError first
        if (
          orderResponse?.response?.success && 
          orderResponse?.response?.screenError?.title === 'Payment in Progress'
        ) {
          console.log('Payment already in progress. Navigating to payment-processing screen...', {
            screenError: orderResponse.response.screenError
          });
          
          // Get orderId from sessionStorage (payment is already in progress)
          const pendingOrderId = sessionStorage.getItem('pendingOrderId');
          const pendingAmount = sessionStorage.getItem('pendingPaymentAmount');
          
          if (pendingOrderId) {
            // Ensure mandateUriOpened flag is set for polling to work
            sessionStorage.setItem('mandateUriOpened', 'true');
            
            // Navigate to payment-processing screen to continue polling
            navigate('/payment-processing', {
              state: {
                orderId: pendingOrderId,
                amount: parseInt(pendingAmount || amountToUse.toString(), 10),
                appName: 'UPI app'
              }
            });
          } else {
            // If no orderId in sessionStorage, still navigate to payment-processing
            // The screen will handle the case where orderId is missing
            console.warn('Payment in progress but no orderId found in sessionStorage');
            sessionStorage.setItem('mandateUriOpened', 'true');
            
            navigate('/payment-processing', {
              state: {
                orderId: null,
                amount: amountToUse,
                appName: 'UPI app'
              }
            });
          }
          return;
        }

        if (orderResponse?.response?.success && orderResponse?.response?.data) {
          const orderData = orderResponse.response.data;
          
          console.log('Order created:', {
            orderId: orderData.orderId,
            mandateUri: orderData.mandateFlowData?.mandateUri,
            amount: orderData.amount
          });
          
          // Step 4: Handle UPI Autopay Mandate URI
          if (orderData.mandateFlowData?.mandateUri) {
            handleUpiMandateUri(
              orderData.mandateFlowData.mandateUri,
              orderData.orderId,
              orderData.amount,
              'UPI app',
              navigate
            );
          } else {
            console.warn('No mandate URI received in response');
            alert('Payment initiated. Order ID: ' + orderData.orderId);
          }
        } else {
          // Check if payment is already in processing
          const pendingOrderId = sessionStorage.getItem('pendingOrderId');
          const mandateUriOpened = sessionStorage.getItem('mandateUriOpened');
          
          // If there's a pending order, payment is likely in processing
          if (pendingOrderId) {
            console.log('Payment already in processing. Navigating to payment-processing screen...');
            
            // Ensure mandateUriOpened flag is set for polling to work
            if (!mandateUriOpened) {
              sessionStorage.setItem('mandateUriOpened', 'true');
            }
            
            // Navigate to payment-processing screen with existing orderId
            navigate('/payment-processing', {
              state: {
                orderId: pendingOrderId,
                amount: parseInt(sessionStorage.getItem('pendingPaymentAmount') || amountToUse.toString(), 10),
                appName: 'UPI app'
              }
            });
          } else {
            console.error('Order creation failed');
            alert('Failed to create order. Please try again.');
          }
        }
      } catch (error: any) {
        console.error('Error processing payment:', error);
        
        // Check if payment is already in processing (from error response or sessionStorage)
        const pendingOrderId = sessionStorage.getItem('pendingOrderId');
        const mandateUriOpened = sessionStorage.getItem('mandateUriOpened');
        
        // Check error message/response for "already processing" or "duplicate order" indicators
        const errorMessage = error?.response?.data?.response?.message || error?.message || '';
        const isProcessingError = 
          errorMessage.toLowerCase().includes('already') ||
          errorMessage.toLowerCase().includes('processing') ||
          errorMessage.toLowerCase().includes('duplicate') ||
          errorMessage.toLowerCase().includes('pending') ||
          error?.response?.status === 409; // Conflict status code
        
        // If there's a pending order or error indicates payment is processing, navigate to payment-processing
        if (pendingOrderId || isProcessingError) {
          console.log('Payment already in processing. Navigating to payment-processing screen...');
          
          const orderIdToUse = pendingOrderId || error?.response?.data?.response?.data?.orderId;
          const amountToUseInError = parseInt(
            sessionStorage.getItem('pendingPaymentAmount') || selectedPlan?.actualPriceAmount?.toString() || planAmount.toString(), 
            10
          );
          
          if (orderIdToUse) {
            // Store orderId if not already stored
            if (!pendingOrderId) {
              sessionStorage.setItem('pendingOrderId', orderIdToUse);
              sessionStorage.setItem('pendingPaymentAmount', amountToUse.toString());
            }
            
            // Ensure mandateUriOpened flag is set for polling to work
            if (!mandateUriOpened) {
              sessionStorage.setItem('mandateUriOpened', 'true');
            }
            
            // Navigate to payment-processing screen
            navigate('/payment-processing', {
              state: {
                orderId: orderIdToUse,
                amount: amountToUseInError,
                appName: 'UPI app'
              }
            });
          } else {
            alert('Failed to process payment. Please try again.');
          }
        } else {
          alert('Failed to process payment. Please try again.');
        }
      }
    };

    if(isInitialCheckoutLoadingScreen){
      return (
            <Loader />
      );
    }

    return (
      <>
        <PaidPlanSubscription
          planState={paidPlanState}
          phoneNumber={userPhoneNumber}
          onPlanSelect={handlePlanSelect}
          onPayClick={handlePayClick}
          onEnterUpiId={handleEnterUpiId}
          upiButtonName={buttonNameState}
        />
        
        {/* UPI ID Modal with Backdrop Blur - For paid plan screen */}
        {showUpiInput && (() => {
          // Always use the minimum value plan amount for UPI ID button
          const plans = paidPlanState?.planData?.plans || [];
          const minimumValuePlan = plans.length > 0 ? plans.reduce((minPlan, currentPlan) => {
            const minAmount = minPlan?.actualPriceAmount || Infinity;
            const currentAmount = currentPlan?.actualPriceAmount || Infinity;
            return currentAmount < minAmount ? currentPlan : minPlan;
          }, plans[0]) : null;
          
          const selectedPlanAmount = minimumValuePlan?.actualPriceAmount || planAmount;
          const minimumPlanId = minimumValuePlan?.id || currentPlanId;
          
          return (
            <UpiIdTextBox 
              onClose={handleBackToPaymentOptions} 
              amount={selectedPlanAmount} // Always minimum value plan amount
              apiAmount={selectedPlanAmount} // Always minimum value plan amount
              planAmount={selectedPlanAmount} // Always minimum value plan amount
              currentPlanId={minimumPlanId} // Always minimum value plan ID
            />
          );
        })()}
      </>
    );
  }

  // Original trial screen rendering
  return (
    <div className={styles.container}>
      {/* Background Glow Effect */}
      <div className={styles.backgroundGlow}>
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          width="360" 
          height="684" 
          viewBox="0 0 360 684" 
          fill="none"
          className={styles.backgroundSvg}
        >
          <g filter="url(#filter0_fn_527_9064)">
            <circle cx="180" cy="92" r="158" fill="#4F5568"/>
          </g>
          <defs>
            <filter 
              id="filter0_fn_527_9064" 
              x="-412" 
              y="-500" 
              width="1184" 
              height="1184" 
              filterUnits="userSpaceOnUse" 
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"/>
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
              <feGaussianBlur stdDeviation="217" result="effect1_foregroundBlur_527_9064"/>
              <feTurbulence 
                type="fractalNoise" 
                baseFrequency="0.5 0.5" 
                stitchTiles="stitch" 
                numOctaves="3" 
                result="noise" 
                seed="2135"
              />
              <feComponentTransfer in="noise" result="coloredNoise1">
                <feFuncR type="linear" slope="2" intercept="-0.5"/>
                <feFuncG type="linear" slope="2" intercept="-0.5"/>
                <feFuncB type="linear" slope="2" intercept="-0.5"/>
                <feFuncA 
                  type="discrete" 
                  tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
                />
              </feComponentTransfer>
              <feComposite 
                operator="in" 
                in2="effect1_foregroundBlur_527_9064" 
                in="coloredNoise1" 
                result="noise1Clipped"
              />
              <feComponentTransfer in="noise1Clipped" result="color1">
                <feFuncA type="table" tableValues="0 0.4"/>
              </feComponentTransfer>
              <feMerge result="effect2_noise_527_9064">
                <feMergeNode in="effect1_foregroundBlur_527_9064"/>
                <feMergeNode in="color1"/>
              </feMerge>
            </filter>
          </defs>
        </svg>
      </div>

      {/* Main Content */}
      <div className={styles.content}>
        {/* Logo */}
        <div className={styles.logoContainer}>
          <img src={logo} alt="Vertical TV by Zupee" className={styles.logo} />
        </div>

        {/* Subscription Details Card for Trial */}
        {isTrialScreen && (
          <SubscriptionDetailsCard
            isTrialTaken={true}
            startingTodayAmount={planStateData?.response?.data?.inactiveFreePlanState?.webView?.trialAmount || "₹2"}
            refundedTodayAmount={planStateData?.response?.data?.inactiveFreePlanState?.webView?.trialAmount || "₹2"}
            futureStartDate={planStateData?.response?.data?.inactiveFreePlanState?.webView?.startDate || ''}
            futureAmount={`${planStateData?.response?.data?.inactiveFreePlanState?.webView?.planAmount}/${planStateData?.response?.data?.inactiveFreePlanState?.webView?.validityValue} ${planStateData?.response?.data?.inactiveFreePlanState?.webView?.validityUnit}`}
            phoneNumber={userPhoneNumber}
            autopayDays={parseInt(planStateData?.response?.data?.inactiveFreePlanState?.webView?.validityValue || '90')}
          />
        )}


        {/* Payment Button Section with Social Proof - Shows on both trial and non-trial screens */}
        {!showUpiInput && (
          <div className={styles.paymentButtonContainer}>
            {/* Social Proof Section */}
            <div className={styles.socialProof}>
              <div className={styles.socialProofContent}>
                <span className={styles.socialProofNumber}>500K+</span>
                <span className={styles.socialProofText}>Happy subscribers 🎉</span>
              </div>
            </div>
            
            {/* Payment Button */}
            <button 
              className={styles.paymentButton}
              onClick={handlePaymentButtonClick}
              disabled={isCheckoutLoading || isCreatingOrder || !planAmount || !currentPlanId}
            >
              {isCheckoutLoading || isCreatingOrder 
                ? 'Processing...' 
                : (
                  <>
                    <img src={upiGroupImages} alt="UPI apps" className={styles.upiGroupIcon} />
                    <span>Pay using UPI apps</span>
                  </>
                )}
            </button>
  
            {/* QR Code Button */}
            {/* <button 
              className={styles.enterUpiButton}
              onClick={handleEnterUpiId}
              disabled={isCheckoutLoading || isCreatingOrder || !planAmount || !currentPlanId}
            >
              <span>Pay using QR Code</span>
            </button> */}

            <button 
              className={styles.enterUpiButton}
              onClick={handleEnterUpiId}
              disabled={!planAmount || !currentPlanId}
            >
              <span>{isInitialCheckoutLoadingScreen ? 'Processing...' : buttonNameState}</span>
            </button>
            
            {/* Enter UPI ID Button */}
            {/* <button 
              className={styles.enterUpiButton}
              onClick={handleEnterUpiId}
              disabled={isCheckoutLoading || isCreatingOrder || !planAmount || !currentPlanId}
            >
              <span>Or Enter UPI ID</span>
            </button> */}
          </div>
        )}
      </div>

      {/* UPI ID Modal with Backdrop Blur */}
      {showUpiInput && (
        <UpiIdTextBox 
          onClose={handleBackToPaymentOptions} 
          amount={displayAmount} // Display amount (₹2 for trial, planAmount for paid)
          apiAmount={planAmount} // API amount (₹549 for trial, planAmount for paid)
          planAmount={planAmount} // Plan amount for initiateSubscriptionCheckout
          currentPlanId={currentPlanId} // Plan ID for initiateSubscriptionCheckout
        />
      )}
    </div>
  );
};

export default SubscriptionPayment;
